<template>
  <div style="padding-top: 70px; background: #fff">
    <div class="header" style="position: fixed">
      <div class="header-left">
        <a @click="$router.back()" class="header-back"></a>
      </div>
      <div class="header-center">
        <h4 class="header-title">取款</h4>
      </div>
      <div class="header-right">
        <a @click="$parent.openKefu" id="gocs_btn" class="header-helper"></a>
      </div>
    </div>
    <div class="mod-withdraw"></div>
    <div class="withdraw-tab tabs-menu">
      <a :class="qutype == 1 ? 'active' : ''" @click="changevT(1)" id="bankCardWithdrawal_btn">银行卡取款</a>
      <a :class="qutype == 2 ? 'active' : ''" @click="changevT(2)" id="usdtWithdraw_btn" class="">USDT取款</a>
    </div>
    <div class="tab" style="font-size: 0.3rem">
      <div id="tab-1" class="tab-content" style="" v-if="qutype == 1">
        <form id="withdraw_form">
          <!-- 用户选择银行卡  -->
          <div id="div_withdraw" class="bgWhite p15 mt10" v-if="!listShow" @click="listShow = true">
            <h4 class="title">请选择银行卡<a class="btn-tutorial fr"></a></h4>
            <ul class="user-bank-wrap">
              <li style="padding-top: 10px" v-if="showInfo.id">
                <a href="javascript:void(0);" id="select_user_bank" class="arrow-r">
                  <span class="user-bank-info">
                    <img :src="showInfo.ico" width="22" height="22" class="fl icon-bank" />
                    <span class="tit"> {{ showInfo.bank }} </span>
                    <span>({{ showInfo.bank_no.substr(-4) }})</span>
                  </span>
                </a>
              </li>
            </ul>
          </div>

          <!-- 用户银行卡list  -->
          <div id="div_select_user_bank_list" class="bgWhite p15 mt10" v-if="listShow">
            <h4 class="title">请选择取款银行卡</h4>
            <ul class="user-bank-wrap" id="ul_select_user_list" style="padding-top: 10px">
              <li v-for="(item, index) in usercardLis" :key="index" style="display: flex; align-items: center; justify-content: start; height: 0.8rem" @click="changInfo(item)">
                <a href="javascript:void(0);" class="bb">
                  <span class="user-bank-info">
                    <img :src="item.ico" width="22" height="22" class="fl icon-bank" />
                    <span class="tit">{{ item.bank }}</span>
                    <span>(尾号{{ item.bank_no.substr(-4) }})</span>
                  </span>
                </a>
              </li>
            </ul>
            <div class="addcard-wrap">
              <a href="javascript:void(0);" v-if="usercardLis.length < 5" @click="$parent.goNav('/addBankCard')" id="li_create_user_bank" class="addcard-btn mtb10"><em>+</em>新增银行卡</a>
            </div>
          </div>

          <!-- 用户取款金额 -->
          <div id="form_wthdraw_" class="mt10" style="">
            <ul class="mod-forms-inputamt">
              <li>
                <h4>打码量</h4>
                <div>
                  <input type="text" v-model="betAmount" id="amount" disabled class="txt-ipt" wdotyn="OFF" placeholder="打码量" />
                </div>
              </li>
              <li>
                <h4>请输入取款金额</h4>
                <div>
                  <input type="text" v-model="amount" id="amount" class="txt-ipt" wdotyn="OFF" placeholder="请输入金额" />
                  <span @click="amount = $store.state.userInfo.balance">全部金额</span>
                </div>
              </li>
              <li style="margin-top: 6px">
                <h4>支付密码</h4>
                <div>
                  <input type="password" autocomplete="new-password" v-model="password" class="txt-ipt" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')"
 wdotyn="OFF" placeholder="支付密码" />
                </div>
              </li>
            </ul>

            <div class="tips p15 red">
              <h1>温馨提示：</h1>
              <p>1、请您在注单结算完成后耐心等待10-15分钟，系统将会自动校正有效流水。详细有效流水规则问题可咨询官网【在线客服】</p>
              <p>2、未参加任何优惠活动存款需投注1倍有效流水（全额投注额）即可提款，如参加活动请参考【活动红利流水相关规则】。</p>
              <p>3、您的提款会依银行支付风控系统判定由一笔或多笔进行支付，ManBetX万博在此承诺，确保到账金额与提款金额一致。</p>
              <p>4、为了确保您的提款金额安全到账，出款银行不支持【网商银行】、【微众银行】，如需出款请绑定其他的出款银行提交，感谢您的配合。</p>
            </div>

            <input
              type="hidden"
              name="eeBlackBox"
              id="eeBlackBox"
              value="0002MDAwN0xTVE9LRU4wMDI0YTRlNDBkMTItOWIyOS00MjM2LTgyZTMtMDJkMWM4NDk4NzZlMDAwNklOVExPQzAwMmFodHRwczovL20ua2FvYWU2a3E0N2I4LmNvbS93YWxsZXQvd2l0aGRyYXcwMDA3UFJJVkFURTAwMDVmYWxzZTAwMDVKRU5CTDAwMDExMDAwNUpTU1JDMDAyMGh0dHBzOi8vd3d3LmY0Ynp5cno5MnVzMy5jb20vRTIvMDAwNFVBR1QwMDgzTW96aWxsYS81LjAgKExpbnV4OyBBbmRyb2lkIDYuMDsgTmV4dXMgNSBCdWlsZC9NUkE1OE4pIEFwcGxlV2ViS2l0LzUzNy4zNiAoS0hUTUwsIGxpa2UgR2Vja28pIENocm9tZS8xMDMuMC4wLjAgTW9iaWxlIFNhZmFyaS81MzcuMzYwMDA3SlNUT0tFTjAwMjRhNGU0MGQxMi05YjI5LTQyMzYtODJlMy0wMmQxYzg0OTg3NmUwMDA3SEFDQ0xORzAwMGV6aC1DTix6aDtxPTAuOTAwMDdIQUNDQ0hSMDAwZlVuaWNvZGUgKFVURi04KTAwMDVKU1ZFUjAwMDMyLjAwMDA0VFpPTjAwMDQtNDgwMDAwNkpTVElNRTAwMTcyMDIyLzA4LzEwIDE0OjI4OjQ3LjgyMjAwMDdTVlJUSU1FMDAxNDgvMTAvMjAyMiAyOjI4OjQ4IFBNMDAwNUpCUk5NMDAwZENocm9tZSBNb2JpbGUwMDA1SkJSVlIwMDA5MTAzLjAuMC4wMDAwNUpCUk9TMDAwYkFuZHJvaWQgNi4wMDAwNUpCUkNNMDAyN05leHVzIDUgQnVpbGQvTVJBNThOOyBLSFRNTCwgbGlrZSBHZWNrbzAwMDVKTEFORzAwMDV6aC1DTjAwMDRKUkVTMDAwNzczNXg0NDMwMDA2SlJFRlJSMDAyN2h0dHBzOi8vbS5rYW9hZTZrcTQ3YjguY29tL3dhbGxldC9pbmRleDAwMDRJR0dZMDAyY3hhMzlMVjVDci8zblVFMis0R2dOdDZza08wUUVHR3B5N3M2dVppdG5EblU9MDAwNUFQVkVSMDA3YjUuMCAoTGludXg7IEFuZHJvaWQgNi4wOyBOZXh1cyA1IEJ1aWxkL01SQTU4TikgQXBwbGVXZWJLaXQvNTM3LjM2IChLSFRNTCwgbGlrZSBHZWNrbykgQ2hyb21lLzEwMy4wLjAuMCBNb2JpbGUgU2FmYXJpLzUzNy4zNjAwMDVBUE5BTTAwMDhOZXRzY2FwZTAwMDVOUExBVDAwMDVXaW4zMjAwMDJNVjAwMjAxRjE2RDVCMEQ5NUFFQzQ0N0U0OTI3NTk2QjY2RDQ0NzAwMDNFVFQwMDU4MFhzcDhjSklUVDB3enI4cVhtVUlVOEZFeHAyQ3JPWVU3MDNobEpmRXM2c2hSaE9BL2RFbVZKd24zZy9yTnN3LzNIQllNMHRLNzB3Z2EwMnErQ2VkVWc9PTAwMDRFVFBUMDA1ODEyQkxVallXa2RHM2dlTnhWK0swbmJRSElEQ3h1RWZYTVQ0ckdaajBmVUd1cmUzTWJLWE1vZ1dNRkZjMThDR2dFOWQzM0hJRG40Z0VvM3pJNHdTeDV3PT0wMDA2Q1RPS0VOMDAyNGE0ZTQwZDEyLTliMjktNDIzNi04MmUzLTAyZDFjODQ5ODc2ZTAwMDhXREJUT0tFTjAwMjRhNGU0MGQxMi05YjI5LTQyMzYtODJlMy0wMmQxYzg0OTg3NmU="
            />

            <div class="p15 mtb15">
              <input id="submitAmount_btn" @click="withdraw" class="confirm-sub" value="立即取款" />
            </div>
          </div>
        </form>
      </div>
      <div id="tab-1" class="tab-content" style="" v-if="qutype == 2">
        <form id="withdraw_form">
          <div id="div_withdraw" class="bgWhite p15 mt10" v-if="!listShow" @click="listShow = true">
            <h4 class="title">请选择USDT地址<a class="btn-tutorial fr"></a></h4>
            <ul class="user-bank-wrap">
              <li style="padding-top: 10px" v-if="showInfo.id">
                <a href="javascript:void(0);" id="select_user_bank" class="arrow-r">
                  <span class="user-bank-info">
                    <img src="/static/image/uacPoGJzdWaAXIAYAAAZE6ysp-Y242.png" width="22" height="22" class="fl icon-bank" />
                    <span class="tit"> {{ showInfo.bank_owner }} </span>
                    <span>(******{{ showInfo.bank_no.substr(-10) }})</span>
                  </span>
                </a>
              </li>
            </ul>
          </div>

          <div id="div_select_user_bank_list" class="bgWhite p15 mt10" v-if="listShow">
            <h4 class="title">请选择USDT地址</h4>
            <ul class="user-bank-wrap" id="ul_select_user_list" style="padding-top: 10px">
              <li v-for="(item, index) in usdssLis" :key="index" style="display: flex; align-items: center; justify-content: start; height: 0.8rem" @click="changInfo(item)">
                <a href="javascript:void(0);" class="bb">
                  <span class="user-bank-info">
                    <img src="/static/image/uacPoGJzdWaAXIAYAAAZE6ysp-Y242.png" width="22" height="22" class="fl icon-bank" />
                    <span class="tit">{{ item.bank_owner }}</span>
                    <span>(******{{ item.bank_no.substr(-10) }})</span>
                  </span>
                </a>
              </li>
            </ul>
            <div class="addcard-wrap">
              <a href="javascript:void(0);" v-if="usdssLis.length < 5" @click="$parent.goNav('/wallet?type=2&show=1')" id="li_create_user_bank" class="addcard-btn mtb10"><em>+</em>新增钱包地址</a>
            </div>
          </div>

          <!-- 用户取款金额 -->
          <div id="form_wthdraw_" class="mt10" style="">
            <ul class="mod-forms-inputamt">
              <li>
                <h4>打码量</h4>
                <div>
                  <input type="text" v-model="betAmount" id="amount" disabled class="txt-ipt" wdotyn="OFF" placeholder="打码量" />
                </div>
              </li>
              <li>
                <h4>请输入取款金额</h4>
                <div>
                  <input type="text" v-model="amount" id="amount" class="txt-ipt" wdotyn="OFF" placeholder="请输入金额" />
                  <span @click="amount = $store.state.userInfo.balance">全部金额</span>
                </div>
              </li>
              <li style="margin-top: 10px">
                <h4>支付密码</h4>
                <div>
                  <input type="password" autocomplete="new-password" v-model="password" class="txt-ipt" maxlength="6" oninput="value=value.replace(/[^0-9]/g,'')"
 wdotyn="OFF" placeholder="支付密码" />
                </div>
                <p id="withdraw_fee" class="withdraw-fee mt15" v-if="chanmeyXi">每笔手续费: {{ chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee : $store.state.userInfo.withdrawfeeusdttrc }} USDT</p>
                <p id="withdraw_fee" class="withdraw-fee mt15">USDT换算：{{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 : '0.00' }} SDT &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;参考汇率：{{ $store.state.userInfo.withdrawusdtrate }}</p>
                <p id="withdraw_fee" class="withdraw-fee mt15">实际到账：{{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 - (chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee * 1 : $store.state.userInfo.withdrawfeeusdttrc * 1) : '0.00' }}USDT</p>
              </li>
            </ul>

            <div class="tips p15 red">
              <h1>温馨提示：</h1>
              <p>1、请您在注单结算完成后耐心等待10-15分钟，系统将会自动校正有效流水。详细有效流水规则问题可咨询官网【在线客服】</p>
              <p>2、未参加任何优惠活动存款需投注1倍有效流水（全额投注额）即可提款，如参加活动请参考【活动红利流水相关规则】。</p>
              <p>3、您的提款会依银行支付风控系统判定由一笔或多笔进行支付，ManBetX万博在此承诺，确保到账金额与提款金额一致。</p>
              <p>4、为了确保您的提款金额安全到账，出款银行不支持【网商银行】、【微众银行】，如需出款请绑定其他的出款银行提交，感谢您的配合。</p>
            </div>

            <input
              type="hidden"
              name="eeBlackBox"
              id="eeBlackBox"
              value="0002MDAwN0xTVE9LRU4wMDI0YTRlNDBkMTItOWIyOS00MjM2LTgyZTMtMDJkMWM4NDk4NzZlMDAwNklOVExPQzAwMmFodHRwczovL20ua2FvYWU2a3E0N2I4LmNvbS93YWxsZXQvd2l0aGRyYXcwMDA3UFJJVkFURTAwMDVmYWxzZTAwMDVKRU5CTDAwMDExMDAwNUpTU1JDMDAyMGh0dHBzOi8vd3d3LmY0Ynp5cno5MnVzMy5jb20vRTIvMDAwNFVBR1QwMDgzTW96aWxsYS81LjAgKExpbnV4OyBBbmRyb2lkIDYuMDsgTmV4dXMgNSBCdWlsZC9NUkE1OE4pIEFwcGxlV2ViS2l0LzUzNy4zNiAoS0hUTUwsIGxpa2UgR2Vja28pIENocm9tZS8xMDMuMC4wLjAgTW9iaWxlIFNhZmFyaS81MzcuMzYwMDA3SlNUT0tFTjAwMjRhNGU0MGQxMi05YjI5LTQyMzYtODJlMy0wMmQxYzg0OTg3NmUwMDA3SEFDQ0xORzAwMGV6aC1DTix6aDtxPTAuOTAwMDdIQUNDQ0hSMDAwZlVuaWNvZGUgKFVURi04KTAwMDVKU1ZFUjAwMDMyLjAwMDA0VFpPTjAwMDQtNDgwMDAwNkpTVElNRTAwMTcyMDIyLzA4LzEwIDE0OjI4OjQ3LjgyMjAwMDdTVlJUSU1FMDAxNDgvMTAvMjAyMiAyOjI4OjQ4IFBNMDAwNUpCUk5NMDAwZENocm9tZSBNb2JpbGUwMDA1SkJSVlIwMDA5MTAzLjAuMC4wMDAwNUpCUk9TMDAwYkFuZHJvaWQgNi4wMDAwNUpCUkNNMDAyN05leHVzIDUgQnVpbGQvTVJBNThOOyBLSFRNTCwgbGlrZSBHZWNrbzAwMDVKTEFORzAwMDV6aC1DTjAwMDRKUkVTMDAwNzczNXg0NDMwMDA2SlJFRlJSMDAyN2h0dHBzOi8vbS5rYW9hZTZrcTQ3YjguY29tL3dhbGxldC9pbmRleDAwMDRJR0dZMDAyY3hhMzlMVjVDci8zblVFMis0R2dOdDZza08wUUVHR3B5N3M2dVppdG5EblU9MDAwNUFQVkVSMDA3YjUuMCAoTGludXg7IEFuZHJvaWQgNi4wOyBOZXh1cyA1IEJ1aWxkL01SQTU4TikgQXBwbGVXZWJLaXQvNTM3LjM2IChLSFRNTCwgbGlrZSBHZWNrbykgQ2hyb21lLzEwMy4wLjAuMCBNb2JpbGUgU2FmYXJpLzUzNy4zNjAwMDVBUE5BTTAwMDhOZXRzY2FwZTAwMDVOUExBVDAwMDVXaW4zMjAwMDJNVjAwMjAxRjE2RDVCMEQ5NUFFQzQ0N0U0OTI3NTk2QjY2RDQ0NzAwMDNFVFQwMDU4MFhzcDhjSklUVDB3enI4cVhtVUlVOEZFeHAyQ3JPWVU3MDNobEpmRXM2c2hSaE9BL2RFbVZKd24zZy9yTnN3LzNIQllNMHRLNzB3Z2EwMnErQ2VkVWc9PTAwMDRFVFBUMDA1ODEyQkxVallXa2RHM2dlTnhWK0swbmJRSElEQ3h1RWZYTVQ0ckdaajBmVUd1cmUzTWJLWE1vZ1dNRkZjMThDR2dFOWQzM0hJRG40Z0VvM3pJNHdTeDV3PT0wMDA2Q1RPS0VOMDAyNGE0ZTQwZDEyLTliMjktNDIzNi04MmUzLTAyZDFjODQ5ODc2ZTAwMDhXREJUT0tFTjAwMjRhNGU0MGQxMi05YjI5LTQyMzYtODJlMy0wMmQxYzg0OTg3NmU="
            />

            <div class="p15 mtb15">
              <input id="submitAmount_btn" @click="withdraw1" class="confirm-sub" value="立即取款" />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'withdrawal',
  data() {
    return {
      usercardLis: [],
      usdssLis: [],
      amount: null,
      bankId: null,
      chanmeyXi: null,
      password: null,
      qutype: 1,
      showInfo: {},
      listShow: false,
      betAmount: null,
    };
  },
  created() {
    let that = this;
    that.getBetAmount();

    that.getUsercard();
    that.getUsdssList();
  },
  methods: {
    getBetAmount() {
      let that = this;
      that.$apiFun
        .post('/api/getBetAmount', {})
        .then(res => {
          if (res.code == 200) {
            that.betAmount = res.data.bet_amount;
          }
        })
        .catch(res => {});
    },
    changInfo(info) {
      let that = this;
      that.showInfo = info;
      that.bankId = info.id;
      this.listShow = false;
      if (that.qutype == 2) {
        let chanmeyXi = null;
        that.usdssLis.forEach(el => {
          if (el.id == info.id) {
            chanmeyXi = el.bank_owner;
            return;
          }
        });
        that.chanmeyXi = chanmeyXi;
      } else {
        that.chanmeyXi = null;
      }
    },

    changevT(val) {
      this.qutype = val;
      this.amount = null;
      this.bankId = null;
      this.chanmeyXi = null;
      this.password = null;
      this.listShow = false;
      this.showInfo = {};
    },
    withdraw() {
      let that = this;
      // amount	是	float	金额
      // bank	是	int	提现银行卡id
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;
      if (!bank) {
        that.$parent.showTost(0, '请选择您要提现到的银行卡');
        return;
      }
      if (amount < 100) {
        that.$parent.showTost(0, '单笔取款不能低于100元');
        return;
      }

      if (!password) {
        that.$parent.showTost(0, '请输入您的支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '提交成功，等待后台审核');

            that.changevT();
            setTimeout(() => {
              that.$router.push({ path: '/transRecord' });
            }, 1500);
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    withdraw1() {
      let that = this;
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;
      if (!bank) {
        that.$parent.showTost(0, '请选择USDT地址');
        return;
      }
      if (amount < 100) {
        that.$parent.showTost(0, '单笔取款不能低于100元');
        return;
      }

      if (!password) {
        that.$parent.showTost(0, '请输入您的支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '提交成功，等待后台审核');
            that.changevT();
            setTimeout(() => {
              that.$router.push({ path: '/transRecord' });
            }, 1500);
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },

    getUsercard() {
      let that = this;
      this.$parent.showLoading();

      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.usercardLis = res.data;
        }
        this.$parent.hideLoading();
      });
    },
    getUsdssList() {
      let that = this;
      this.$parent.showLoading();

      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
        this.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.mod-forms li .form-ipt {
  margin-left: 95px;
}
.mod-forms li .form-ipt .txt-ipt {
  width: 82%;
}
.select2-container--default .select2-selection--single {
  border: 0 !important;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
  line-height: 43px !important;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
  top: 10px !important;
}

#div_create_user_bank .mod-f-l li a {
  display: block;
  height: 38px;
  line-height: 38px;
  padding: 0;
}
#div_create_user_bank .mod-f-l li > a {
  background: url(https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/icon_withdraw1.png) no-repeat 14px 8px;
  background-size: 22px;
}
#div_create_user_bank .mod-f-l li > a > span {
  padding-left: 42px;
  color: #4e4e4e;
}
#div_create_user_bank .mod-f-l li a a {
  background: #fff;
  padding: 0 15px;
}
#div_create_user_bank .mod-f-l .icon-bank {
  margin-top: 8px;
}
#div_create_user_bank .arrow-r {
  margin-top: 10px;
  margin-right: 15px;
}

@media (max-width: 320px) {
  /* iphone 4 */
  #div_create_user_bank ul li .form-ipt input {
    width: 53%;
  }
}

.withdraw-tab {
  margin: 10px 5px;
  background: #fff;
  display: flex;
  height: 50px;
  border-radius: 5px;
  justify-content: space-around;
  align-items: center;
}
.withdraw-tab a {
  font-size: 14px;
  color: #a8a8a8;
  position: relative;
  width: 47%;
  padding: 10px 0;
  text-align: center;
}
.withdraw-tab a.active {
  color: #ff944b;
  border: 1px solid #fdd0ad;
  border-radius: 5px;
  font-weight: bold;
  pointer-events: none;
}

#form_withdraw_crypto_ {
  margin-top: 10px !important;
}
#form_withdraw_crypto_ .mod-forms li {
  height: auto;
  padding: 10px 15px;
  border-radius: 0;
  border: none;
  margin-top: -1px;
}
#form_withdraw_crypto_ .mod-forms li:first-of-type {
  margin-bottom: 0;
  padding-bottom: 5px;
}
#form_withdraw_crypto_ .mod-forms li:nth-of-type(2) {
  padding-top: 0;
  margin: 0;
}
#form_withdraw_crypto_ .mod-forms li .cwinfo {
  line-height: 30px;
}
#form_withdraw_crypto_ .mod-forms li:nth-of-type(3) {
  padding-top: 0;
  margin: 0;
}
#form_withdraw_crypto_ .mod-forms li .form-ipt {
  font-size: 15px;
  color: #4e4e4e;
}
#form_withdraw_crypto_ .mod-forms li .conversion.red {
  border-top: 1px solid #f2f2f2;
}
#form_withdraw_crypto_ .mod-forms li label {
  width: auto;
  text-align: left;
  font-size: 15px;
  color: #4e4e4e;
}
#form_withdraw_crypto_ .mod-forms li label.withdraw-pwtitle {
  background: url(https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/icon_withdraw6.png) no-repeat 0 11px;
  background-size: 22px 22px;
  padding-left: 30px;
}
#form_withdraw_crypto_ .mod-forms li > span {
  position: relative;
  padding-left: 7px;
  font-weight: bold;
}
#form_withdraw_crypto_ .mod-forms li > span:before {
  content: '';
  background: #fcb23a;
  width: 3px;
  height: 14px;
  display: inline-flex;
  position: absolute;
  left: -3px;
  bottom: -1px;
}
#form_withdraw_crypto_ .dollar-sign {
  font-family: arial, sans-serif;
  font-size: 23px;
  font-weight: bold;
}
#form_withdraw_crypto_ .yuan-key {
  float: right;
  line-height: 50px;
}
#form_withdraw_crypto_ h1 {
  background: none !important;
  line-height: 19px;
}
#form_withdraw_crypto_ #withdraw_fee_crypto {
  width: 100%;
}
.btn-tutorial,
.btn-tutorial-usdt {
  background: url(/static/image/icon_tutorial.png) no-repeat center left;
  background-size: 20px;
  width: 66px;
  display: inline;
  position: relative;
  padding-left: 25px;
}
.btn-tutorial em {
  font-weight: normal;
}
.quick-amt {
  display: flex;
  justify-content: space-between;
  text-align: center;
}
.quick-amt a {
  min-width: 15.5%;
  line-height: 30px;
  height: 30px;
  border-radius: 5px;
  padding: 0 5px;
  border: 1px solid #d1d1d1;
  background: #fff;
}
.quick-amt a.selected {
  color: #ff944b;
  border: 1px solid #fdd0ad;
}
.quick-amt a > input {
  line-height: 30px;
}
.info_p {
  line-height: 18px;
  color: #999;
  margin: 0 10px 14px;
}
#form_card h2 {
  display: block;
  background: #fff;
  color: #ff944b;
}
#form_card .login-wrap {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 60vh;
  padding: 0 5%;
  margin: 0;
}
#form_card .popup-wrap {
  max-height: 90vh;
  overflow: hidden;
}
#form_card .login-wrap .mod-forms label {
  padding-left: 30px;
  background: no-repeat 10px 10px;
  background-size: 22px;
}
#form_card .login-wrap .mod-forms li .form-ipt .txt-ipt {
  width: 85%;
}
@media (max-width: 320px) {
  #form_card .login-wrap .mod-forms li .form-ipt .txt-ipt {
    width: 80%;
  }
}
.popup-bankcryptowallet .popup-wrap h2 {
  font-size: 20px;
  font-weight: normal;
  border: 0;
}
.popup-bankcryptowallet .popup-close {
  background: url(https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/ico_close.png) no-repeat;
  background-size: 100% 100%;
  width: 16px;
  height: 16px;
  top: 27px;
}
.popup-bankcryptowallet .login-wrap li label {
  color: #4c4c4c;
  font-size: 13px;
}
.popup-bankcryptowallet .login-wrap li input {
  border-radius: 5px;
  font-size: 12px;
  width: 100%;
  border: 1px solid lightgrey;
  line-height: 30px;
  height: 30px;
  margin: 5px 0;
  text-indent: 5px;
}
.popup-bankcryptowallet .login-wrap li input::placeholder {
  color: #686868;
}
.popup-bankcryptowallet .login-wrap li input.btn-sub {
  background: none;
  border: 0;
  line-height: normal;
  height: auto;
  margin: 0;
  color: #222;
  text-indent: 0;
}
.popup-bankcryptowallet .login-wrap li em {
  font-size: 14px;
  color: #ff8624;
  position: relative;
  top: 2px;
  left: 0px;
  text-align: right;
}
.popup-bankcryptowallet .login-wrap .info_p {
  color: #ff944b;
  letter-spacing: 0;
  font-size: 12px;
  margin: 2px 0 15px 0;
}
.popup-bankcryptowallet .login-wrap select {
  background: #f0f0f0;
  border-radius: 5px;
  font-size: 14px;
  width: 100%;
  color: #a8a8a8;
  border: 0;
  line-height: 30px;
  height: 30px;
  padding: 0 5px;
  margin: 5px 0;
}
.popup-bankcryptowallet .login-wrap select select {
  background: #fff;
}
.popup-bankcryptowallet .remark_type {
  margin: 5px 0 10px 0;
}
.popup-bankcryptowallet .remark_type a {
  padding: 5px;
  background: #f0f0f0;
  border-radius: 2px;
  margin-right: 8px;
  color: #808080;
}
.popup-bankcryptowallet .remark_type a.selected {
  background: #ff944b;
  color: #fff;
}
.popup-bankcryptowallet .mobile label,
.popup-bankcryptowallet .verify label {
  width: 75px;
  display: inline-flex;
}
.popup-bankcryptowallet .verify .form-ipt {
  width: calc(100% - 94px);
  display: inline-block;
  border-radius: 5px;
  border: 1px solid lightgrey;
}
.popup-bankcryptowallet .verify .form-ipt input {
  background: none;
  height: 20px;
  line-height: 20px;
}
.popup-bankcryptowallet .verify .form-ipt input.txt-ipt {
  width: calc(100% - 75px);
}
.popup-bankcryptowallet .verify .form-ipt #verify_mobile_btn {
  color: #f7a915;
  font-size: 12px;
  text-indent: 0px;
  width: 68px;
  margin-right: 5px;
  float: right;
  border: 0;
}
.popup-bankcryptowallet .login-wrap li.mobile input {
  width: calc(100% - 95px);
}
.card-wrap {
  max-width: 100%;
}
.card-item {
  max-width: 100%;
  background: #fff;
  padding: 10px 0;
  border-radius: 10px;
  color: #383838;
  transition: left 1s;
  left: 0;
  height: auto;
  box-shadow: 0 6px 26px -6px rgb(0 0 0 / 10%);
}
.card-item.cur {
  left: -20%;
  position: relative;
  max-width: 100%;
}
.card-item > div {
  padding: 0 10px 0 20px;
  position: relative;
}
.card-item > div.bank-name {
  color: #383838;
  line-height: 25px;
}
.card-item > div.bank-node {
  color: #5a5a5a;
  font-size: 12px;
}
.card-item > div.card-num {
  margin-top: 15px;
  font-size: 12px;
}
.card-item > div.card-num input {
  border: 0;
  height: 25px;
  width: calc(100% - 30px);
}
.card-item > div.bank-delete {
  display: none;
  background: url(https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/ico_delete.png) no-repeat center/40px;
  width: 24%;
  height: 40px;
  display: block;
  transition: right 1s;
  right: -24%;
  top: 30%;
  position: absolute;
}
.card-item .bank-edit {
  background: url(https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/ico_edit.png) no-repeat center/25px;
  width: 25px;
  height: 25px;
  display: inline-block;
  position: absolute;
  right: 4%;
  bottom: 0;
}
.card-item .bank-edit.active {
  background: url(https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/ico_saved.png) no-repeat center/25px;
}
.addcard-btn {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.addcard-btn em {
  font-size: 24px;
  line-height: 1;
  vertical-align: -1px;
  margin-right: 5px;
  font-weight: 100;
}
.addcard-btn input {
  color: #ff944b;
  background: none;
  border: 0;
  font-size: 16px;
  font-weight: bold;
}
.crypto-btn {
  margin: 5p;
  display: flex;
}
.crypto-btn a {
  min-height: 66px;
  width: 33%;
  margin: 0 2px;
}
.huobi-icon {
  background-image: url(https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/usdt_huobi_icon.png);
  background-repeat: no-repeat;
  background-size: contain;
}
.bian-icon {
  background-image: url(https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/usdt_bian_icon.png);
  background-repeat: no-repeat;
  background-size: contain;
}
.okex-icon {
  background-image: url(https://static-content-m.lzy7m3r40rld.com:9587/images/d11_img/usdt_okex_icon.png);
  background-repeat: no-repeat;
  background-size: contain;
}
#mobile_code,
#mobile_code_crypto {
  border: 0;
}
.container-bankcode {
  width: 247px;
  height: 37px;
  margin-top: 4px;
}
.add_bankcode_crypto {
  float: left;
  width: auto;
  padding: 6px 15px;
  text-align: center;
  border-radius: 5px;
  border: 1px solid #d1d1d1;
  margin-right: 5px;
  position: relative;
}
.selectedprotocol {
  color: #ff944b;
  border: 1px solid #ff944b;
}
.selectedprotocol:before {
  content: '';
  background: url(/static/image/icon_selected.png) no-repeat;
  background-size: 20px;
  width: 20px;
  height: 15px;
  position: absolute;
  right: -1px;
  bottom: -1px;
  border-radius: 0 0 5px;
}

#usdtaccessModal h2 {
  text-align: center;
  color: #ff6e23;
  background: #fecb8b;
  border-radius: 5px 5px 0 0;
  font-weight: bold;
}

#usdtaccessModal.modal {
  overflow: inherit;
}

#usdtaccessModal.modal .modal-close {
  background: url(/static/image/icon_popusdt_close.png) no-repeat center;
  background-size: 35px;
  width: 35px;
  height: 35px;
  position: absolute;
  bottom: -60px;
  top: auto;
  right: 45%;
}
#usdtaccessModal.modal .modal-content {
  padding: 0 20px;
}
.image_con {
  width: 200px;
  margin: 0 auto;
}

.image_con img {
  width: 100%;
  margin: 20px 0 10px;
}

.clear {
  clear: both;
}
.greendiv img,
.reddiv img {
  width: 20px;
}
.usdt_href {
  float: right;
}

.taggroup > span {
  position: relative;
  left: 10px;
  font-weight: bold;
}

.usdtaccess > span {
  position: relative;
  left: 10px;
  font-weight: bold;
  line-height: 17px;
}

.access1,
.unable_access1 {
  margin-top: 10px;
}
.content_h5 {
  max-height: 356px !important;
}

.tabs-menu-protocol {
  font-size: 14px;
  font-weight: 500;
  margin-top: 11px;
  display: flex;
}

.tabs-menu-protocol li {
  width: 53px;
  height: 40px;
  text-align: center;
  float: left;
  padding: 0 15px;
  line-height: 40px;
  border: 1px solid #fdd0ad;
  border-radius: 10px;
  margin-left: 6px;
  margin-top: 5px;
}

.tab-content-protocol {
  display: none;
}

#tabs-container-protocol {
  background: white;
  height: 58px;
}

input.btn-sub {
  background: none;
  border: 0;
}
.currents {
  background-color: rgb(255, 169, 0);
}

.currents a {
  color: white !important;
}

.currents a > input {
  color: white !important;
}
.currents a:hover {
  color: white !important;
}

.cryptowallet-display {
  background: white;
  height: 85px;
  margin-top: 30px;
}

.cryptowallet-display ul {
  min-width: 440px;
}

.cryptowallet-display li {
  width: 154px;
  background: #fff;
  margin-left: 12px;
  height: 60px;
  float: left;
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: 3px;
  border: 1px solid lightgrey;
  border-radius: 5px;
  position: relative;
  padding: 5px 0;
  font-size: 12px;
}

.usdt-num {
  overflow: hidden;
}

.addnew {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #656565;
  margin-right: 0;
  height: 59px;
}
.addnew:before {
  content: '+';
  font-size: 17px;
  display: block;
  color: #ffa900;
  font-weight: bold;
}

.addnew > a > input {
  padding-left: 5px;
}

.bankcard-list {
  margin-top: 20px;
}

.bankcard-list li {
  display: inline-block;
  width: 271px;
  float: left;
  color: #4d4d4d;
  font-size: 14px;
  line-height: 1.3;
}

.bankcard-list li > div {
  position: relative;
  margin: 10px 20px;
  border: 1px solid #b6b6b6;
  padding: 5px 15px;
  border-radius: 5px;
  display: flex;
}

.bankcard-list li > div:before {
  content: '';
  display: block;
  position: absolute;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  border: 2px solid #b6b6b6;
  left: -20px;
  top: 50%;
  margin-top: -7px;
}

.bankcard-list li > div img {
  max-width: 27px;
  max-height: 27px;
  display: block;
  float: left;
  margin-right: 15px;
  margin-top: 3px;
}

.bank-no {
  overflow: hidden;
}

.modal-footer a {
  width: 193px;
  border-radius: 20px;
  padding: 7px 40px;
  line-height: 60px;
  display: inline-block;
  text-align: center;
  margin-top: 65px;
  color: #959595;
  cursor: pointer;
  transition: background 0.3s, border 3s, color 0.3s;
  font-size: 14px;
}

.orange-btn {
  background: linear-gradient(to right, #fe8d43, #fbcc80);
  color: #fff !important;
}

.grey-border-btn {
  background: #e0e0e0;
  color: #4b4b4b !important;
}

.modal-new .modal-footer {
  text-align: center;
  padding: 10px 0 25px;
}

.cryptowallet-display li.cur {
  border: 1px solid #fcb23a;
}

.cryptowallet-display li.cur:before {
  content: '';
  background: url(/static/image/icon_selected.png) no-repeat;
  background-size: 20px;
  width: 20px;
  height: 15px;
  position: absolute;
  right: -1px;
  bottom: -1px;
  border-radius: 0 0 5px;
}

.card-bank {
  padding: 0 0 0 30px;
  align-items: center;
}

.card-bank em {
  padding: 5px 0;
  color: #cacaca;
  display: block;
}

.usdt-no {
  overflow: hidden;
  padding: 0px 30px 5px;
  text-align: left;
  margin-right: 5px;
}

.bankcard-list li.cur > div {
  border: 2px solid #fcb23a;
  margin: 9px 19px;
}

.bankcard-list li.cur > div:after {
  content: '';
  display: block;
  position: absolute;
  border-radius: 50%;
  width: 6px;
  height: 6px;
  background: #fcb23a;
  left: -16px;
  top: 50%;
  margin-top: -3px;
}

.cryptoListModal .modal-hd h2 {
  color: #ff944c;
  font-weight: bold;
}
.cryptoListModal .modal-content .bankcard-list li em {
  display: block;
  color: #ff944c;
  margin: 5px 0;
}
.cryptoListModal .modal-footer {
  padding: 10px 0 0;
}
.cryptoListModal .modal-footer a {
  width: auto;
  padding: 7px 50px;
  line-height: 30px;
}
.cryptoListModal .modal-content .bankcard-list {
  margin-top: 0;
}
.cryptoListModal .modal-content .bankcard-list li > div {
  margin: 9px 0 9px 30px;
}
.cryptoListModal .modal-content .bankcard-list li.cur > div {
  border: 1px solid #ffcca5;
}
.cryptoListModal .modal-content .bankcard-list li > div img {
  margin: 3px 5px 3px -8px;
}
.cryptoListModal .modal-content .bankcard-list li > div:before {
  width: 16px;
  height: 16px;
  left: -30px;
}
.cryptoListModal .modal-content .bankcard-list li > div:after {
  background: url(/static/image/icon_ticked.png) center;
  background-size: 21px;
  width: 21px;
  height: 21px;
  left: -30px;
  top: 44%;
}
.close-bankcryptowallet {
  font-size: 18px;
  position: absolute;
  right: 20px;
  top: 8px;
  z-index: 999;
}
#switchusdt img {
  width: 25px;
  height: 24px;
  float: right;
  margin-top: -4px;
  margin-right: 4px;
}

.modal-reminder {
  width: 90%;
  max-width: 500px;
  padding: 20px;
  top: 50% !important;
  transform: translate(-50%, -50%);
  border: 2px solid #ffb162;
  border-radius: 10px;
  background: url(/static/image/modal_reminder_logo.png) #fff no-repeat center / 120%;
  box-sizing: border-box;
}
.modal-reminder .modal-hd {
  padding-bottom: 25px;
  background: url(/static/image/modal_reminder_deco.png) no-repeat bottom / contain;
}
.modal-reminder .modal-hd h2 {
  font-size: 22px;
  margin: 0 15px;
  padding: 0;
  text-align: center;
  font-weight: bold;
}
.modal-reminder .modal-hd h2 i {
  width: 24px;
  height: 24px;
  margin-right: 6px;
  vertical-align: -4px;
  background: no-repeat center / 100%;
  background-image: url(/static/image/icon_logo.png), url(/static/image/icon_logo.png);
  display: inline-block;
}
.modal-reminder .modal-close {
  top: 10px;
  right: 10px;
}
.modal-reminder .modal-content {
  margin: 20px auto 30px;
  padding: 0;
  font-size: 14px;
  text-align: center;
}
.modal-reminder .modal-footer {
  display: flex;
  justify-content: center;
}
.modal-reminder .modal-footer a {
  width: 45%;
  min-width: 130px;
  height: 45px;
  padding: 0 10px;
  font-size: 16px;
  margin: 0 auto;
  border-radius: 5px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-reminder .modal-btn-1 {
  background: linear-gradient(0deg, #feac64 0%, #ffd38b 100%);
  color: #ffffff !important;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3);
  border: none;
}
.modal-reminder .modal-btn-2 {
  background: #ffffff;
  color: #ffb162 !important;
  border: 2px solid #ffb162 !important;
}

#wtdReminderModal .modal-content p {
  line-height: 24px;
}
#wtdReminderModal .modal-content i {
  width: 16px;
  height: 16px;
  background: center / 100%;
  vertical-align: -3px;
  display: inline-block;
}
#wtdReminderModal .modal-content i.bell {
  background-image: url(/static/image/icon_bell.png);
  margin-right: 2px;
}
#wtdReminderModal .modal-content i.speed {
  background-image: url(/static/image/icon_speed.png);
}
#wtdReminderModal .modal-content i.star {
  background-image: url(/static/image/icon_star.png);
  margin-left: 2px;
}
#wtdReminderModal .modal-content i.smile {
  background-image: url(/static/image/icon_smile.png);
}

#form_wthdraw_ .tips.red h1 {
  color: #ff0000 !important;
}
#form_wthdraw_ .red {
  color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/components/withdrawal.vue